<script>
    export let cpu;
    export let ram;
    export let paypalLink;
    export let paypalLinkDE;
    export let paypalLinkUSE;
    export let paymentLink;
    export let paymentLinkDE;
    export let paymentLinkUSE;
    export let firstName;
    export let secondName;
    export let color;

    function germany() {
        document.getElementById(firstName + "paypal").href = paypalLinkDE;
        document.getElementById(firstName + "stripe").href = paymentLinkDE;
        document.getElementById(firstName + "img").src =
            "https://upload.wikimedia.org/wikipedia/en/b/ba/Flag_of_Germany.svg";
        document.getElementById(secondName + "img").src =
            "https://upload.wikimedia.org/wikipedia/en/b/ba/Flag_of_Germany.svg";
    }
    
    function us() {
        document.getElementById(firstName + "paypal").href = paypalLink;
        document.getElementById(firstName + "stripe").href = paymentLink;
        document.getElementById(firstName + "img").src =
            "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg";
        document.getElementById(secondName + "img").src =
            "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg";
    }

    function use() {
        document.getElementById(firstName + "paypal").href = paypalLinkUSE;
        document.getElementById(firstName + "stripe").href = paymentLinkUSE;
        document.getElementById(firstName + "img").src =
            "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg";
        document.getElementById(secondName + "img").src =
            "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg";
    }

    function checkCountry()
    {
        if(document.getElementById('locations'+firstName).value=="usw")
        {
            us();
        }
        if(document.getElementById('locations'+firstName).value=="de")
        {
            germany();
        }
        if(document.getElementById('locations'+firstName).value=="use")
        {
            use();
        }
    }
</script>
<style>
    .growa:hover
    {
        transition: 0.3s ease;
        -webkit-transform: scale(1.1);
        -ms-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>

<!-- This example requires Tailwind CSS v2.0+ -->
<form class="mt-4 border-2 border-blue-600 rounded-lg mx-1 py-1">
    <label for="locations{firstName}">🌎Location:</label>
    <select on:change="{checkCountry}" name="locations{firstName}" id="locations{firstName}" class="rounded-lg border-none outline-none {!color ? 'bg-gray-900' : 'bg-white'} ">
      <option value="usw">US West (Seattle)</option>
      <option value="use">US East (Ashburn)</option>
      <option value="de">EU Central (Frankfurt)</option>
    </select>
</form>

  

<div class="pt-4">
    <ul class="text-sm text-gray-100 w-full mt-1 mb-6">
        <li
            class="mb-3 flex items-center from-yellow-600 to-red-500 bg-gradient-to-r rounded-md p-2"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
                />
            </svg>

            {cpu}
        </li>
        <li
            class="mb-3 flex items-center from-green-600 to-purple-500 bg-gradient-to-r rounded-md p-2"
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6.75 8.75C6.75 7.64543 7.64543 6.75 8.75 6.75H15.25C16.3546 6.75 17.25 7.64543 17.25 8.75V15.25C17.25 16.3546 16.3546 17.25 15.25 17.25H8.75C7.64543 17.25 6.75 16.3546 6.75 15.25V8.75Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M9.75 4.75V6.25"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M19.25 9.75L17.75 9.75"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M9.75 17.75V19.25"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M6.25 9.75L4.75 9.75"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M14.25 4.75V6.25"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M19.25 14.25L17.75 14.25"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M14.25 17.75V19.25"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M6.25 14.25L4.75 14.25"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
            {ram}
        </li>
        <li
            class="mb-3 flex items-center from-blue-600 to-red-500 bg-gradient-to-r rounded-md p-1"
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M4.75 11.75H19.25V18.25C19.25 18.8023 18.8023 19.25 18.25 19.25H5.75C5.19771 19.25 4.75 18.8023 4.75 18.25V11.75Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M4.75 14V11.9068C4.75 11.8029 4.76618 11.6996 4.79797 11.6008L6.77693 5.44399C6.90986 5.03044 7.29457 4.75 7.72896 4.75H16.271C16.7054 4.75 17.0901 5.03044 17.2231 5.44399L19.202 11.6008C19.2338 11.6996 19.25 11.8029 19.25 11.9068V14"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M7.75 15.25H9.25"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M12.75 15.25H16.25"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>

            Unmetered Storage
        </li>
        <li
            class="mb-3 flex items-center {color
                ? 'text-gray-700'
                : 'text-white'}"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
                />
            </svg>

            10 Databases
        </li>
        <li
            class="mb-3 flex items-center {color
                ? 'text-gray-700'
                : 'text-white'}"
        >
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M19.25 17.25V9.75C19.25 8.64543 18.3546 7.75 17.25 7.75H4.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25H17.25C18.3546 19.25 19.25 18.3546 19.25 17.25Z"
                />
                <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M13.5 7.5L12.5685 5.7923C12.2181 5.14977 11.5446 4.75 10.8127 4.75H6.75C5.64543 4.75 4.75 5.64543 4.75 6.75V11"
                />
            </svg>

            10 Backups
        </li>
        <li
            class="mb-3 flex items-center {color
                ? 'text-gray-700'
                : 'text-white'}"
        >
            <svg
                class="h-6 w-6 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                width="6"
                height="6"
                stroke="currentColor"
                fill="#10b981"
                viewBox="0 0 1792 1792"
            >
                <path
                    d="M1412 734q0-28-18-46l-91-90q-19-19-45-19t-45 19l-408 407-226-226q-19-19-45-19t-45 19l-91 90q-18 18-18 46 0 27 18 45l362 362q19 19 45 19 27 0 46-19l543-543q18-18 18-45zm252 162q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
                />
            </svg>
            Premium Panel
        </li>
    </ul>
</div>
<a id={firstName+"stripe"} href={paymentLink} class="">
    <div
        class="w-full bg-gradient-to-r from-red-500 to-purple-700 mt-8 rounded-xl text-white growa"
    >
        
        <div class="flex flex-wrap py-4">
            <img
                id={secondName + "img"}
                src="https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg"
                alt="United States"
                class="rounded-lg h-6 w-10 mx-auto"
            />
            <span class="font-medium mx-auto"> Checkout with Credit Card </span>

            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="inline h-6 w-6 mr-auto"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
            </svg>
        </div>
        
    </div>
</a>
<a id={firstName+"paypal"} href={paypalLink} class="">
    <div
        class="w-full py-4 bg-gradient-to-r from-blue-500 to-blue-700 mt-8 rounded-xl text-white flex flex-wrap growa"
    >
        <img
            id={firstName + "img"}
            src="https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg"
            alt="United States"
            class="rounded-lg my-auto h-6 w-10 mx-auto"
        />
        <span class="font-medium  mx-auto">Checkout with PayPal </span>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="inline h-6 w-6 mr-auto"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
            />
        </svg>
    </div>
</a>
